import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { TConfirmationModalData } from '@dss-libs/shared/type/common-types';
import { AbstractModalComponent } from '../../../abstract/abstract-modal/abstract-modal.component';

@Component({
  selector: 'juno-libs-ui-confirmation-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent extends AbstractModalComponent<TConfirmationModalData> {
  protected readonly initials = computed(() => {
    const name = this.dialogData?.participant?.name ?? '';
    return name
      .split(' ')
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? '')
      .join('');
  });

  protected confirm(): void {
    this.completeAndCloseModal();
  }
}
